import clsx from 'clsx'
import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { RevampAdultsPickerContainer } from './RevampAdultsPickerContent'
import {
  NumberInputRange,
  NumberInputRangeRef,
} from '../number-input-range/number-input-range'

type AdultsPickerContentModalProps = {
  revampPicker: boolean
  field: ControllerRenderProps<FieldValues, string>
  onIsAdultSelected?: (value: boolean) => void
  maxAdults?: number
  isMobile: boolean
  onCloseModal?: () => void
  onChange?: (value: number | undefined) => void
  onValid?: () => void
}

export const AdultsPickerContentModal = React.forwardRef<
  NumberInputRangeRef,
  AdultsPickerContentModalProps
>(
  (
    {
      revampPicker,
      field,
      onIsAdultSelected,
      maxAdults,
      isMobile,
      onCloseModal,
      onChange,
      onValid,
    },
    ref,
  ) => {
    const intl = useIntl()

    const onChangeMobileRevamp = (value?: number) => {
      field.onChange(value)
      onIsAdultSelected?.(!!value && value > 0)
    }

    if (revampPicker) {
      return (
        <RevampAdultsPickerContainer
          label={
            <FormattedMessage
              id='ui.AdultsPickerContentModal.title'
              defaultMessage='Entrez le nombre de participants'
            />
          }
          inputTextProps={{
            placeholder: intl.formatMessage({
              id: 'ui.AdultsPickerContentModal.adultsNumberPlaceholder',
              defaultMessage: 'Nombre de participants',
            }),
            inputContainerClassName: s.inputText,
            className: s.inputTextContainer,
          }}
          onClose={onCloseModal}
          field={field}
          onIsAdultSelected={onIsAdultSelected}
          isMobile={isMobile}
          onChange={onChangeMobileRevamp}
          onValid={onValid}
          ref={ref}
        />
      )
    }

    return (
      <div className={clsx({ [s.mobileInputRange]: isMobile })}>
        <NumberInputRange
          label={
            <FormattedMessage
              id='ui.indexAdultPicker.label.adults'
              defaultMessage='Voyageurs'
            />
          }
          value={field.value ?? 5}
          onChange={onChange}
          min={2}
          max={maxAdults || 999}
          textField={{
            placeholder: intl.formatMessage({
              id: 'ui.AdultsPicker.adultsNumberPlaceholder',
              defaultMessage: 'Nombre voyageurs',
            }),
            className: s.numberInputRangeTextField,
          }}
          height={30}
          ref={ref}
        />
      </div>
    )
  },
)
